// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { addListener, removeListeners, makeEvent } from "~/lib/signals";
import { CONFIG } from "~/config";
import ContentFull from "~/content.full";
import { _ } from "~/i18n";
import { store } from "~/state/store";
import Canonical from "~/canonical";
import { frpc } from "./util/general";
import { isoZoneToUTC } from "~/util/format";

/**
 * Komponenta na zobrazovani galerii v sirkach 2 a 3. Sourozenec od Mapy.Pano a Mapy.M3D.
 */
Mapy.Timeboard = class extends ContentFull {
	constructor() {
		super();
		this._contentName = "timeboard";
		this._detailSignals = [];
		this._stateCache = null;
		this._data = null;
		this._actualType = "";
		this._usedExceptions = [];

		this._sheetCache = [];
		this._state = {
			l: 0, // id linky
			d: 0, // smer
			i: 0  // casove rozmezi (pracovni den/sobota/nedele)
		};

		this._const = {
			PADDING: 100, // [px]
			MIN_CONT_WIDTH: 550, // [px]
			MIN_RIGHT_COLUMN_WIDTH: 298 // [px]
		};

		this._dom = {
			container: node("div", { id: "timeboard" }),
			header: node("div", { className: "header" }),
			title: node("h4"),
			subtitle: node("p"),
			sheetContainer: node("div", { className: "sheet-container" }),
			tabs: node("ul", { className: "tabs" }),
			linesContainer: node("div"),
			validityContainer: node("div", {className: "timeboard-validity"}),
			intervalList: node("ul", {className: "tabs"}),
			daySelected: node("span", {className: "blind", innerHTML: _("timeboard.blind.selected")}),
			lineTypeSelected: node("span", {className: "blind", innerHTML: _("timeboard.blind.selected")}),
			validitySelected: node("span", {className: "blind", innerHTML: _("timeboard.blind.selected")}),
			notes: Mapy.Util.node("div", {className: "timetable-notes"})
		};

		this._buildCloseButton();
		addListener(this, "width-change-start", "_widthChangeStart");
		addListener(this, "width-change", "_widthChangeStop");
		addListener(this, "resize", "_updateSize");
		addListener(this, "print-page", "_printPage");
		addListener(this, "print-done", "_printDone");
		this._build();
		this._updateSize();
		this._printPromise = null; //tisknutelná promise;
	};

	_clickClose(e, elm) {
		makeEvent("change-active-type", this, { type: this._actualType });
		super._clickClose(e, elm);
	}

	_build() {
		this._dom.header.appendChild(this._dom.title);
		this._dom.header.appendChild(this._dom.subtitle);
		this._dom.header.appendChild(node("h5", {id: "blind_header", className: "blind", innerHTML: "záhlaví"}));
		this._dom.header.setAttribute("role", "banner");
		this._dom.header.setAttribute("aria-labelledby", "blind_header");

		this._dom.container.appendChild(this._dom.header);
		this._dom.container.appendChild(node("h5", {id: "transport_type", className: "blind", innerHTML: _("timeboard.blind.selectTransport")}));
		this._dom.container.appendChild(this._dom.tabs);
		this._dom.container.appendChild(this._dom.linesContainer);
		this._dom.container.appendChild(this._dom.validityContainer);
		this._dom.container.appendChild(this._dom.sheetContainer);
		this._dom.sheetContainer.setAttribute("role", "main");
		this._dom.sheetContainer.setAttribute("aria-labelledby", "main_content");
		this._dom.container.appendChild(node("h5", {id: "main_content", className: "blind", innerHTML: _("timeboard.blind.mainContent")}));
	}

	getNames(type) {
		var obj = {
			"bus": _("timeboard.names.buses"),
			"tram": _("timeboard.names.trams"),
			"metro": _("timeboard.names.metro"),
			"lanovka": _("timeboard.names.cableWays"),
			"privoz": _("timeboard.names.ferryBoats"),
			"metroa": _("timeboard.names.metro") + " A",
			"metrob": _("timeboard.names.metro") + " B",
			"metroc": _("timeboard.names.metro") + " C",
			"vlak": _("timeboard.names.trains"),
			"trolejbus": _("timeboard.names.troleys")
		};

		if (type in obj) {
			return (obj[type]);
		}
		else if (type.match(/metro\d+/)) {
			return _("timeboard.names.metro");
		}
		else return "";
	}

	_getSingularNames(type) {
		var obj = {
			"bus": _("timeboard.names.bus"),
			"tram": _("timeboard.names.tram"),
			"metro": _("timeboard.names.metro"),
			"lanovka": _("timeboard.names.cableWay"),
			"privoz": _("timeboard.names.ferryBoat"),
			"metroa": _("timeboard.names.metro") + " A",
			"metrob": _("timeboard.names.metro") + " B",
			"metroc": _("timeboard.names.metro") + " C",
			"vlak": _("timeboard.names.train"),
			"trolejbus": _("timeboard.names.troley")
		};

		if (type in obj) {
			return (obj[type]);
		}
		else if (type.match(/metro\d+/)) {
			return _("timeboard.names.metro");
		}
		else return "";
	}

	_getGenitiveNames(type) {
		var obj = {
			"bus": _("timeboard.genitatives.bus"),
			"tram": _("timeboard.genitatives.tram"),
			"metro": _("timeboard.genitatives.metro"),
			"lanovka": _("timeboard.genitatives.cableWay"),
			"privoz": _("timeboard.genitatives.ferryBoat"),
			"metroa": _("timeboard.genitatives.metro") + " A",
			"metrob": _("timeboard.genitatives.metro") + " B",
			"metroc": _("timeboard.genitatives.metro") + " C",
			"vlak": _("timeboard.genitatives.train"),
			"trolejbus": _("timeboard.genitatives.troley")
		};

		if (type in obj) {
			return (obj[type]);
		}
		else if (type.match(/metro\d+/)) {
			return _("timeboard.genitatives.metro");
		}
		else return "";
	}

	getIcon(type) {
		var obj = {
			"bus": "bus",
			"tram": "tram",
			"metro": "metro",
			"lanovka": "lanovka",
			"privoz": "privoz",
			"metroa": "metro",
			"metrob": "metro",
			"metroc": "metro",
			"vlak": "vlak",
			"trolejbus": "trolejbus"
		};

		if (type in obj) {
			return ("/img/detail/" + obj[type] + ".svg");
		}
		else if (type.match(/^metro/)) {
			return ("/img/detail/metro.svg");
		}

		else return "";
	};

	setData(data, title, subtitle) {
		this._data = window.structuredClone(data);

		this._dom.title.innerHTML = title;
		this._dom.subtitle.innerHTML = subtitle;
		this._dom.tabs.innerHTML = "";
		this._dom.linesContainer.innerHTML = "";
		this._dom.linesContainer.appendChild(node("h5", {id: "line_select", className: "blind", innerHTML: _("timeboard.blind.selectLine")}));

		for (var i = 0, len = this._data.length; i < len; i++) {
			var lineType = node("li", { className: "tab" });

			lineType.style.backgroundImage = "url('" + this.getIcon(this._data[i].type) + "')";
			lineType.insertAdjacentHTML("beforeend", this._data[i].label);
			lineType.setAttribute("data-log-action", "timeboard-type-activate");
			lineType.setAttribute("data-log-type", this._data[i].type);
			lineType.setAttribute("role", "link");
			lineType.setAttribute("tabindex", "0");
			lineType.addEventListener("keyup", this, false);

			var lines = node("ul", { className: "lines" });
			lines.setAttribute("role", "navigation");
			lines.setAttribute("aria-labelledby", "line_select");
			lineType.__lines = lines;
			lines.__tab = lineType;
			if (this._data[i].type == "metroa" || this._data[i].type == "metrob" || this._data[i].type == "metroc") {
				lines.classList.add("metro");
			}

			var items = this._sortLines(this._data[i].lines);

			for (var x = 0, l = items.length; x < l; x++) {
				var line = node("li", { className: "number" });
				if (items[x].night) { line.classList.add("night"); }
				if (this._data[i].type == "metro") { // metro dostane jeste classu podle sveho nazvu
					line.classList.add("metro" + items[x].title.toLowerCase());
				}
				line.setAttribute("data-line-id", items[x].id);
				line.setAttribute("data-line-direction", items[x].departures[0].direction);
				line.setAttribute("data-log-action", "timeboard-line-activate");
				line.setAttribute("data-log-line", items[x].title);

				var linkHref = this.generateLink({
					line: items[x].id,
					direction: items[x].departures[0].direction
				});

				var link = node("a", { className: "link", href: linkHref });
				link.setAttribute("aria-label", ((items[x].night ? _("timeboard.blind.dayNightLineType.nightLine") : _("timeboard.blind.dayNightLineType.dayLine")) + " " + items[x].title));

				var linkNumber  =node("span", {innerHTML: items[x].title});
				linkNumber.setAttribute("aria-hidden", "true");
				link.appendChild(linkNumber);
				if (items[x].id == this._state.l) {
					line.classList.add("active");
					lines.classList.add("visible");
					this._dom.lines = lines;
					lineType.classList.add("active");
					lineType.removeAttribute("role");
					link.setAttribute("href", "#");
					this._actualType = this._data[i].type;
					lineType.appendChild(this._dom.lineTypeSelected);
					link.setAttribute("aria-label", link.getAttribute("aria-label") + " " + _("timeboard.blind.selected"));
				}

				line.appendChild(link);
				lines.appendChild(line);
			}

			this._dom.linesContainer.appendChild(lines);
			this._dom.tabs.appendChild(lineType);

			if (this._stateCache && (this._state.l === 0 || this._stateCache.l == this._state.l)) {
				this.setSheet(this._stateCache.l, this._stateCache.d, this._stateCache.i, this._stateCache.v);
			}
		}
		this._dom.tabs.setAttribute("role", "navigation");
		this._dom.tabs.setAttribute("aria-labelledby", "transport_type");
	}

	setState(state) {
		if ("timeboard" in state) {
			this.activate();

			try {
				this._stateCache = JSON.parse(state.timeboard);
			} catch (ex) {
				this._stateCache = { l: 0, d: 1, i: undefined, v: null };
			}

			const { data } = store.getState().detail;

			if (data) {
				this._detailReady();
			} else {
				this._detailSignals.push(addListener(this, "detail-activated", "_detailReady"));
				this._detailSignals.push(addListener(this, "detail-error", "_responseSheetError"));
			}
		}
		this["timeboard" in state ? "activate" : "deactivate"]();
	}

	_detailReady(e) {
		if (this._detailSignals.length) {
			removeListeners(this._detailSignals);
			this._detailSignals = [];
		}
	}

	getState() {
		var state = {
			l: this._state.l,
			d: this._state.d
		};
		if (this._state.i != undefined) { state.i = this._state.i; }
		if (this._validity) { state.v = this._validity; };
		return { timeboard: JSON.stringify(state) };
	}

	activate() {
		if (this.isActive()) { return this; }

		this._appendCloseButton();

		Mapy.getComponent("layout").getScrollNode().addEventListener("scroll", this, false);
		window.addEventListener("resize", this, false);

		this._dom.container.addEventListener("click", this, false);

		return super.activate();
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		super.deactivate();

		this._removeCloseButton();
		this._dom.container.classList.remove("scroll");

		window.removeEventListener("resize", this, false);
		this._removeSheetListeners();
		Mapy.getComponent("layout").getScrollNode().removeEventListener("scroll", this, false);
		this._dom.container.removeEventListener("click", this, false);

		return this;
	}

	handleEvent(e) {
		super.handleEvent(e);
		if (e.type == "scroll") {
			if (e.target.scrollTop > 0 && !this._dom.title.classList.contains("scroll")) {
				this._dom.container.classList.add("scroll");
				this._widthChange();
			}
			else if (e.target.scrollTop == 0 && this._dom.container.classList.contains("scroll")) {
				this._dom.container.classList.remove("scroll");
				this._dom.title.style.width = "";
				this._dom.title.style.right = "";
			}
		}

		if (e.type == "resize") {
			this._widthChange();
		}

		if (e.type == "click" || (e.type == "keyup" && e.key == "Enter")) {
			this._dom.container.classList.remove("error");

			if (e.target.closest(".tab") && !e.target.closest(".active")) { // zmena tabu

				if (e.target.__lines) {
					//this._resetValidity();
					this.setSheet(e.target.__lines.firstChild.getAttribute("data-line-id"), parseInt(e.target.__lines.firstChild.getAttribute("data-line-direction")));
				} else if (e.target.__validity) {
					this._resetValidity();
					e.target.classList.add("active");
					this._buildSheet(this._state.l, this._state.d, this._state.i, this._state.s, e.target.__validity);
				}
				Mapy.getComponent("history").save();
			}

			if (e.target.closest(".link")) { // klik na linku nad plachtou
				e.preventDefault();
				//this._resetValidity();
				var number = e.target.closest(".link").parentNode;

				if (!number.classList.contains("active")) {
					this.setSheet(number.getAttribute("data-line-id"), parseInt(number.getAttribute("data-line-direction")));
					Mapy.getComponent("history").save();
				}
			}
			var link = e.target.closest("a[data-pubt-id]");
			if (link && !Mapy.Util.linkToNewWindow(e)) {
				e.preventDefault();


				this._setValidation();
				Mapy.getComponent("detail").setState({
					source: "pubt",
					id: parseInt(link.getAttribute("data-pubt-id") || "0"),
					show: true,
				}).then(function() {
					Mapy.getComponent("history").save();
				}, () => {});
				this.setState(this.getState());
			}
		}
	}

	/**
	 * Pokud je nová šířka layoutu 1 nebo 0, deaktivuje panel
	 * @param {type} e
	 * @return {}
	 */
	_widthChangeStart(e) {
		if (Mapy.getComponent("print").isPrinting) { return; }
		if (e.data.newWidth < 2) { this.deactivate(); }
	}

	/**
	 * Pokud se tiskne a panel JŘ se zmenšil, vyresolví se tisková promise (v dependencies tisku)
	 */
	_widthChangeStop() {
		if (!this.isActive()) { return; }
		if (Mapy.getComponent("layout").getWidth() < 2 && Mapy.getComponent("print").isPrinting) {
			this._printPromise.resolve();
			this._printPromise = null;
		}
	}

	/**
	 * Nastaví vyrobí tiskovou promisi, přidá ji do závislostí a spustí zmenšení plachty (aby v tisku nebyla malá mapa)
	 */
	_printPage() {
		if (!this.isActive()) { return; }
		this._printPromise = Mapy.Util.createPrintPromise();
		Mapy.getComponent("print").addDepends(this._printPromise);
		Mapy.getComponent("layout").setWidth(1);
	}

	/**
	 * Po dokončení printscreenování mapy nastaví šířku plachty opět na velkou
	 */
	_printDone() {
		if (!this.isActive()) { return; }
		Mapy.getComponent("layout").setWidth(2);
	}

	_widthChange() {
		if (this._dom.container.classList.contains("scroll")) {
			var layout = Mapy.getComponent("layout"),
				body = layout.getBody(),
				scrollNode = layout.getScrollNode(),
				bodyW = body.offsetWidth;

			this._dom.header.style.width = (bodyW - 200) + "px";
			this._dom.header.style.right = (scrollNode.offsetWidth - bodyW) + "px";
		}
	}

	_removeSheetListeners() {
		if (this._ecDirectionChange && this._dom.directionChange) {
			this._dom.directionChange.removeEventListener("click", this._ecDirectionChange, false);
			this._ecDirectionChange = null;
		}
		if (this._ecTimetableChange && this._dom.timetableSwitch) {
			this._dom.timetableSwitch.removeEventListener("click", this._ecTimetableChange, false);
			this._ecTimetableChange = null;
		}
		if (this._actualHourTimer) {
			clearTimeout(this._actualHourTimer);
		}
	}

	setSheet(line, direction, timetable, validity, signId) {
		if (typeof line !== "string") {
			line = line.toString();
		}
		// ulozeni do historie
		this._state.l = line;
		this._state.d = direction;
		this._state.i = timetable;

		// zneaktivneni stareho
		var tab = this._dom.container.querySelector("li.tab.active");
		if (tab) {
			tab.classList.remove("active");
			if (tab.__lines) {
				tab.__lines.classList.remove("visible");
			}
		}
		var number = this._dom.container.querySelector("li.number.active");
		if (number) { number.classList.remove("active"); }

		// aktivace noveho
		var lineULs = this._dom.container.querySelectorAll("ul.lines");
		var alRegExp = new RegExp(" " + _("timeboard.blind.selected"), "g");

		for (var x = 0, l = lineULs.length; x < l; x++) {
			var lines = lineULs[x].childNodes;
			for (var i = 0, len = lines.length; i < len; i++) {
					var link = lines[i].querySelector("a");
					var ariaLabel = link.getAttribute("aria-label").replace(alRegExp, "");
					link.setAttribute("aria-label", ariaLabel);

				if (lines[i].getAttribute("data-line-id") == line) {
					this._dom.lines = lines[i].parentNode;
					lines[i].classList.add("active");
					lines[i].parentNode.__tab.classList.add("active");
					this._actualType = lines[i].parentNode.__tab.getAttribute("data-log-type");
					lines[i].parentNode.classList.add("visible");
					link.setAttribute("aria-label", ariaLabel + " " + _("timeboard.blind.selected"));
				}
			}
		}

		const detailData = store.getState().detail.data || { id: 0 };
		const stopId = parseInt(signId || detailData.id || detailData.extend?.station);

		if (!validity) {
			this._setValidation();
		}

		// ziskani dat zastavkoveho jizdniho radu a jeho sestaveni
		for (var i = 0, len = this._sheetCache.length; i < len; i++) {
			if (this._sheetCache[i].line == line && this._sheetCache[i].direction == direction && this._sheetCache[i].stopId == stopId) {
				this._state.s = this._sheetCache[i].sheet;
				this._buildSheet(line, direction, timetable, this._sheetCache[i].sheet, this._validity);
				return;
			}
		}

		if (this._request) {
			this._request.abort();
			Mapy.getComponent("loader").end(true);
		}
		this._clearSheet();
		this._dom.container.appendChild(Mapy.getComponent("loader").getBigCon());
		Mapy.getComponent("loader").start(true);

		const frpcData = frpc({
			url: CONFIG.requestUrl + "/jrpoifrpc/",
			method: "sheetIntervals",
			args: [stopId, line, direction, {lang: CONFIG.langPriority}],
		});

		this._request = frpcData.request;
		frpcData.promise.then(e => this._responseSheet(e, line, direction, timetable), e => this._responseSheet(e, line, direction, timetable));
	}

	_responseSheet(e, line, direction, timetable) {
		if (e.name === "AbortError") {
			return;
		}

		Mapy.getComponent("loader").end(true);

		var loaderCon = Mapy.getComponent("loader").getBigCon();
		if (loaderCon.parentNode == this._dom.container) {
			loaderCon.remove();
		}

		var status = e.status;
		this._dom.container.classList.remove("error");

		if (status >= 200 && status < 300) {
			const { source, id } = store.getState().detail;

			this._state.s = e.sheet;

			this._sheetCache.push({
				line: line,
				direction: direction,
				stopId: parseInt(id || "0"),
				sheet: e.sheet
			});
			this._buildSheet(line, direction, timetable, e.sheet, this._validity);

			Canonical.set("/", {
				source,
				id,
				timeboard: this.getState().timeboard,
			});
		}
		else if (status === 404) {
			if (this._dom.lines) {
				this._dom.lines.classList.add("visible");
			}

			this._dom.container.classList.add("error");
			this._dom.sheetContainer.appendChild(node("p", { innerHTML: _("timeboard.error404") }));

			this._stateCache = null;

			for (var i = 0; i < this._data.length; i++) {
				var item = this._data[i];

				if (item.type) {
					this._actualType = item.type;
					break;
				}
			}

			Mapy.setPhantomMeta(404);
		}
		else {
			this._responseSheetError();
		}
	}

	_responseSheetError() {
		Mapy.getComponent("loader").end(true);

		var loaderCon = Mapy.getComponent("loader").getBigCon();
		if (loaderCon.parentNode == this._dom.container) {
			loaderCon.remove();
		}

		this._dom.container.classList.add("error");
		this._dom.sheetContainer.appendChild(node("p", { innerHTML: _("error.info", _("error.tryAgain")) }));
	}

	_clearSheet() {
		// smazat stary obsah a odvesit posluchace
		this._dom.sheetContainer.innerHTML = "";
		this._dom.validityContainer.innerHTML = "";
		this._dom.notes.innerHTML = "";
		this._removeSheetListeners();
		this._usedExceptions = [];
	}

	_buildSheet(line, direction, timetable, sheet, validityObj) {
		this._clearSheet();
		// ziskat data pro jednotlivé časové úseky
		var currentValidation = 0;
		if (validityObj) {
			// najdu odpovídající datum validního JŘ
			for (var i in sheet.intervals) {
				if (sheet.intervals[i].validFromISO === validityObj.from &&  sheet.intervals[i].validToISO === validityObj.to) {
					currentValidation = i;
				}
			}
		}
		var dataAll = sheet.intervals.slice();
		var timeTableException = [];

		if (!dataAll) { return; }

		//intervály
		var intFrag = document.createDocumentFragment();
		var intervalHead = node("h2", {innerHTML: _("timeboard.validity")});
		var intervalList = node("ul", {className: "tabs"});
		for (var inter = 0; inter < dataAll.length; inter++) {
			var li = node("li", {className: "tab", innerHTML: (inter === 0 && (new Date(dataAll[inter].validFromISO)).getTime() < Date.now() ? "" : _("timeboard.timeFromTo.from") + " " + this._getIntervalDate(dataAll[inter].validFromISO) + " ") + _("timeboard.timeFromTo.to") + " " + this._getIntervalDate(dataAll[inter].validToISO)});
			li.__validity = {from: dataAll[inter].validFromISO, to: dataAll[inter].validToISO};
			intervalList.appendChild(li);
		}

		if (intervalList.children[currentValidation]) {
			intervalList.children[currentValidation].classList.add("active");
			intervalList.children[currentValidation].appendChild(this._dom.validitySelected);
		}
		else {
			return;
		}

		intFrag.appendChild(intervalHead);
		intFrag.appendChild(intervalList);
		this._dom.validityContainer.appendChild(intFrag);

		var data = dataAll[currentValidation];
		var frag = document.createDocumentFragment();


		// hlavicka
		var header = node("h3");
		var directions = [];

		// máme jiné směry?
		const { data: stopDetail } = store.getState().detail;

		for (var sd in stopDetail.extend.transportlines) {
			if (stopDetail.extend.transportlines[sd].type === this._actualType) {
				for (var tl in stopDetail.extend.transportlines[sd].lines) {
					if (stopDetail.extend.transportlines[sd].lines[tl].id === line) {
						for (var dr in stopDetail.extend.transportlines[sd].lines[tl].departures) {
							var currentDirection = stopDetail.extend.transportlines[sd].lines[tl].departures[dr].direction;
							if (directions.indexOf(currentDirection) === -1) {
								directions.push(currentDirection);
							}
						}
					}
				}
			}
		}
		if (directions.length > 1) {
			this._dom.directionChange = node("button", { innerHTML: _("timeboard.changeDirection")});
			this._ecDirectionChange = function(line, direction, timetable) {
				this._state.d = -direction;
				this.setSheet(line, this._state.d, timetable, { from: data.validFromISO, to: data.validToISO });
				Mapy.getComponent("history").save();
			}.bind(this, line, direction, timetable, data);
			this._dom.directionChange.addEventListener("click", this._ecDirectionChange, false);
			this._dom.directionChange.setAttribute("data-log-action", "timeboard-direction-change");
			frag.appendChild(this._dom.directionChange);
		}
		header.insertAdjacentHTML("beforeend", '<span class="blind">' + _("timeboard.blind.direction.from") + '</span> ' + data.stopList[0].title + ' <span aria-hidden="true">&rarr;</span><span class="blind">' + _("timeboard.blind.direction.to") + '</span> ' + data.stopList[data.stopList.length - 1].title);
		frag.appendChild(header);

		// pravy sloupec
		var rightColumn = node("div", { className: "right-column" });
		frag.appendChild(rightColumn);

		// stranky s casy a jejich prepinac
		this._dom.timetableSwitch = node("ul", { className: "timetable-switch" });
		this._dom.timetableSwitch.setAttribute("role", "navigation");
		this._dom.timetableSwitch.setAttribute("aria-labelledby", "day_select");
		rightColumn.appendChild(node("h5", {id: "day_select", className: "blind", innerHTML: _("timeboard.blind.selectDay")}));
		rightColumn.appendChild(this._dom.timetableSwitch);

		this._dom.timetableContainer = node("div", { className: "timetable-container" });
		rightColumn.appendChild(this._dom.timetableContainer);
		var tIndex = timetable == undefined ? -1 : (timetable >= 0 && timetable < data.timeTables.length ? timetable : 0);
		for (var i = 0, len = data.timeTables.length; i < len; i++) {
			var active = (tIndex == -1 && data.timeTables[i].active) || i == tIndex;
			var li = node("li", { innerHTML: data.timeTables[i].title });
			li.setAttribute("data-log-action", "timeboard-timetable-change");
			li.setAttribute("data-log-timetable", data.timeTables[i].title);
			li.setAttribute("data-table", i);
			li.setAttribute("role", "link");
			li.setAttribute("tabindex", "0");
			li.addEventListener("keyup", this, false);

			this._dom.timetableSwitch.appendChild(li);
			if (active) {
				li.classList.add("active");
				li.removeAttribute("role");
				li.appendChild(this._dom.daySelected);
				var table = node("table", { className: "timetable" + (active ? " active" : "") });
				table.setAttribute("role", "presentation");
				var hours = node("tbody");
				hours.setAttribute("role", "presentation");
				table.appendChild(hours);
				for (var x = 0, l = data.timeTables[i].hours.length; x < l; x++) {
					var tr = node("tr");
					tr.setAttribute("role", "presentation");
					tr.setAttribute("data-hour", data.timeTables[i].hours[x].hour);
					var firstCell = node("td", { innerHTML: data.timeTables[i].hours[x].hour });
					firstCell.setAttribute("aria-hidden", "true");
					firstCell.setAttribute("role", "presentation");
					var secondCell = node("td", {innerHTML: (data.timeTables[i].hours[x].minutes ? this._buildMinutes(data.timeTables[i].hours[x].minutes, data.timeTables[i].hours[x].hour, data.exceptionList) : "")});
					secondCell.setAttribute("role", "presentation");

					tr.appendChild(firstCell);
					tr.appendChild(secondCell);
					hours.appendChild(tr);
				}
				this._dom.timetableContainer.appendChild(table);


				timeTableException = data.timeTables[i].timeTableExc || [];
			}
		}
		this._ecTimetableChange = (e) => {
			if (e.target.tagName.toLowerCase() == "li") {
				var index = parseInt(e.target.getAttribute("data-table"));
				this.setSheet(this._state.l, this._state.d, index);
				Mapy.getComponent("history").save();
			}
		};
		this._dom.timetableSwitch.addEventListener("click", this._ecTimetableChange, false);

		// platnost
		var datum = isoZoneToUTC(data.validToISO);
		var validity = node("p", { className: "valid-through", innerHTML: _("timeboard.validUntil") + " " + Mapy.Util.dateToLocaleFormat(datum).replace(/\./g, ". ") });


		// dopravce - zdroj stejny -> pouze dopravce; prvni dopravci, pak zdroje
		var sourcesData = this._getSourcesData(sheet);

		if (!sourcesData.empty) {
			if (sourcesData.agencies.length) {
				var agency = node("p", { className: "agency", innerHTML: _("timeboard.agency") + ": " + sourcesData.agencies.join(", ") });
				this._dom.notes.appendChild(agency);
			}

			if (sourcesData.origins.length) {
				var origin = node("p", { className: "origin", innerHTML: _("timeboard.origin") + ": " + sourcesData.origins.join(", ") });
				this._dom.notes.appendChild(origin);
			}
		}
		else {
			validity.classList.add("last");
		}

		// zastavky, kterymi linka projizdi
		var table = node("table", { className: "line" });
		table.setAttribute("role", "navigation");
		table.setAttribute("role", "presentation");
		table.setAttribute("aria-labelledby", "select_stop");
		var stops = node("tbody");
		stops.setAttribute("role", "presentation");

		table.appendChild(stops);

		var exTitles = {};

		for (var i = 0; i < data.exceptionList.length; i++) {
			exTitles[data.exceptionList[i].letter] = data.exceptionList[i].text;
		}

		for (var i = 0, len = data.stopList.length; i < len; i++) {
			var tr = node("tr");
			tr.setAttribute("role", "presentation");
			var time = typeof(data.stopList[i].time_run) === "number" ? data.stopList[i].time_run : "";
			if (data.stopList[i].isStart) {
				tr.classList.add("actual");
				time = "&bull;";
				tr.setAttribute("tabindex", "0");
			}
			var timeTd = node("td", { innerHTML: this._formatTime(time) });
			timeTd.setAttribute("role", "presentation");
			tr.appendChild(timeTd);
			var td = node("td");
			td.setAttribute("role", "presentation");
			if (data.stopList[i].isStart || i == data.stopList.length - 1) {
				td.innerHTML = data.stopList[i].title + (data.stopList[i].isStart ? '<span class="blind"> ' + _("timeboard.blind.selected") + '</span>' : "");
			} else {
				var tb = encodeURIComponent(this.getState().timeboard);
				td.innerHTML = '<a href="?source=pubt&amp;id=' + data.stopList[i].id + '&amp;timeboard=' + tb + '" data-pubt-id="' + data.stopList[i].id + '">' + data.stopList[i].title + '</a>';
			}
			switch (data.stopList[i].poiId) {
				case 24:
					if (sheet.routeTitle != "A") { td.appendChild(node("img", { src: "/img/detail/metro_a.png", title: _("timeboard.transfer.A") })); }
					if (sheet.routeTitle != "B") { td.appendChild(node("img", { src: "/img/detail/metro_b.png", title: _("timeboard.transfer.B") })); }
				break;
				case 25:
					if (sheet.routeTitle != "B") { td.appendChild(node("img", { src: "/img/detail/metro_b.png", title: _("timeboard.transfer.B") })); }
					if (sheet.routeTitle != "C") { td.appendChild(node("img", { src: "/img/detail/metro_c.png", title: _("timeboard.transfer.C") })); }
				break;
				case 26:
					if (sheet.routeTitle != "A") { td.appendChild(node("img", { src: "/img/detail/metro_a.png", title: _("timeboard.transfer.A") })); }
					if (sheet.routeTitle != "C") { td.appendChild(node("img", { src: "/img/detail/metro_c.png", title: _("timeboard.transfer.C") })); }
				break;
				case 27:
					if (sheet.routeTitle != "A") { td.appendChild(node("img", { src: "/img/detail/metro_a.png", title: _("timeboard.transfer.A") })); }
				break;
				case 28:
					if (sheet.routeTitle != "B") { td.appendChild(node("img", { src: "/img/detail/metro_b.png", title: _("timeboard.transfer.B") })); }
				break;
				case 29:
					if (sheet.routeTitle != "C") { td.appendChild(node("img", { src: "/img/detail/metro_c.png", title: _("timeboard.transfer.C") })); }
				break;
			}
			// vysvetlivky u zastavky
			for (var x = 0; x < data.stopList[i].stopExc.length; x++) {
				if (["♿", "@"].indexOf(data.stopList[i].stopExc[x]) != -1) {
					td.appendChild(node("em", { className: "note disability", innerHTML: "y", title: exTitles[data.stopList[i].stopExc[x]] }));
				} else {
					td.appendChild(node("em", { className: "note", innerHTML: data.stopList[i].stopExc[x], title: exTitles[data.stopList[i].stopExc[x]] }));
				}
			}
			tr.appendChild(td);
			stops.appendChild(tr);
		}
		frag.appendChild(node("h5", {id: "select_stop", className: "blind", innerHTML: _("timeboard.blind.selectStop")}));
		frag.appendChild(table);

		// vysvetlivky
		this._usedExceptions = this._usedExceptions.filter(function(value, index, self) {
			return self.indexOf(value) === index;
		});
		if (data.exceptionList.length) {
			var notes = node("div", { className: "explanation-notes" });
			notes.appendChild(node("h5", {className: "blind", innerHTML: _("timeboard.blind.explanation")}));
			for (var i = 0, len = data.exceptionList.length; i < len; i++) {
				if (this._usedExceptions.indexOf(data.exceptionList[i].letter) != -1) {
					if (["♿", "@"].indexOf(data.exceptionList[i].letter) != -1) {
						notes.appendChild(node("p", { innerHTML: '<em class="note disability">y</em> &ndash; ' + data.exceptionList[i].text }));
					} else {
						notes.appendChild(node("p", { innerHTML: data.exceptionList[i].letter + " &ndash; " + data.exceptionList[i].text }));
					}
				}
			}

			// globalni vyjimky vztahujici se k cele plachte
			for (var i = 0; i < timeTableException.length; i++) {
				notes.appendChild(node("p", { innerHTML: timeTableException[i] }));
			}

			this._dom.notes.appendChild(notes);
		}
		this._dom.notes.appendChild(validity);
		rightColumn.appendChild(this._dom.notes);

		// finalni vlozeni do DOMu + clearfix
		frag.appendChild(node("div", { className: "clear" }));
		this._dom.sheetContainer.appendChild(frag);
		this._dom.rightColumn = rightColumn;

		// zvyraznovani aktualni hodiny
		this._highlightHour();
		this._highlighSign();
		this._updateSize();

		//SEO
		var seoTitle = this._getSingularNames(this._actualType) + " " + sheet.routeTitle + " " + _("timeboard.from") + " " + sheet.stopTitle + " " + _("timeboard.direction") + " " + data.stopList[data.stopList.length-1].title;
		var seoDesc = _("timeboard.timetable") + " " + this._getGenitiveNames(this._actualType) + " " + sheet.routeTitle + " " + _("timeboard.fromStop") + " " + sheet.stopTitle + " " + _("timeboard.toward") + " " + data.stopList[data.stopList.length-1].title;
		Mapy.SEO.set(seoTitle, seoDesc);
	}

	_highlightHour() {
		var date = new Date();
		var list = document.querySelectorAll(".sheet-container .timetable-container table tr");
		var hour = date.getHours();
		var minute = date.getMinutes();

		// najdi a zvyrazni hodiny, ktere maji byt zvyraznene a ostatnim to zrus
		for (var i = 0, len = list.length; i < len; i++) {
			var item = list[i];
			var itemHour = parseInt(item.getAttribute("data-hour"));

			var lc = item.querySelector("td:last-child");
			var h5 = lc.querySelector("h5");

			if (itemHour == hour || (minute > 49 && itemHour == hour + 1)) {
				item.classList.add("now");
				if (!h5) {
					lc.insertAdjacentHTML("afterbegin", node("h5", {className: "blind", innerHTML: _("timeboard.blind.closestLine")}).outerHTML);
				}

			} else {
				item.classList.remove("now");
				h5?.remove();
			}
		}


		// nastav casovac
		if (this._actualHourTimer) {
			clearTimeout(this._actualHourTimer);
		}
		this._actualHourTimer = setTimeout(this._highlightHour.bind(this), 30000);
	}

	_buildMinutes(minutes, hour, exc) {
		var parts = [];
		var exTitles = {};

		for (var i = 0; i < exc.length; i++) {
			exTitles[exc[i].letter] = exc[i].text;
		}

		for (var i = 0, len = minutes.length; i < len; i++) {
			var blindSpans = [];
			// sestav vyjimky
			var departureException = "";
			if (minutes[i].departureExc) {
				var dExc = [];
				for (var x = 0, l = minutes[i].departureExc.length; x < l; x++) {
					blindSpans.push('<span>' + exTitles[minutes[i].departureExc[x].letter] + '</span>');
					if (["♿", "@"].indexOf(minutes[i].departureExc[x].letter) != -1) {
						dExc.push('<em class="note disability" title="' + exTitles[minutes[i].departureExc[x].letter] + '" aria-hidden="true">y</em>');
					} else {
						dExc.push('<em class="note" title="' + exTitles[minutes[i].departureExc[x].letter] + '" aria-hidden="true">' + minutes[i].departureExc[x].letter + '</em>');
					}
					this._usedExceptions.push(minutes[i].departureExc[x].letter);
				}
				departureException = dExc.join("");
			} else if (minutes[i].departureLetter) {
				departureException = '<em class="note">' + minutes[i].departureLetter + "</em>";
			}

			// dej dohromady minutu
			var blindMin = '<span class="blind">' + hour + ' ' + _("timeboard.blind.hours") + ' ' + minutes[i].departureMinute + ' min' + blindSpans.join("") + '</span>';
			parts.push(blindMin + '<span aria-hidden="true">' + minutes[i].departureMinute.toString().lpad(0, 2) + departureException + " </span>");
		}

		return parts.join("");
	}

	_highlighSign() {
		var state = this._state;
		var signId = [];

		for (var i = 0; i < this._data.length; i++) {
			var type = this._data[i];

			for (var y = 0; y < type.lines.length; y++) {
				var l = type.lines[y];

				if (state.l == parseFloat(l.id)) {
					for (var z = 0; z < l.departures.length; z++) {
						var d = l.departures[z];
						if (state.d == d.direction) {
							signId = d.signId;
							break;
						}
					}
					break;
				}
			}
		}

		makeEvent("request-sign-type", this, { id: signId });
	}

	_updateSize() {
		var contWidth = this._const.MIN_CONT_WIDTH;
		var columnWidth = this._const.MIN_RIGHT_COLUMN_WIDTH;

		this._dom.sheetContainer.style.width = contWidth + "px";
		this._dom.validityContainer.style.width = (contWidth  + 2) + "px";

		if (this._dom.rightColumn) {
			this._dom.rightColumn.style.width = columnWidth + "px";

			var tableEl = this._dom.timetableContainer.querySelector(".timetable");

			if (tableEl) {
				var rows = tableEl.querySelectorAll("tbody tr") || [];
				var max = -Infinity;
				var row = null;

				for (var i = 0; i < rows.length; i++) {
					var count = (rows[i].querySelectorAll("span[aria-hidden]") || []).length;

					if (count > max) {
						max = count;
						row = rows[i];
					}
				}

				if (row) {
					var availWidth = this._dom.container.offsetWidth - this._const.PADDING * 2 - this._const.MIN_CONT_WIDTH;
					var allSpan = row.children[1].querySelectorAll("span[aria-hidden]");

					if (!allSpan.length) return;

					var spanWidth = allSpan[0].offsetWidth;
					var start = Math.floor(row.children[1].offsetWidth / spanWidth);
					var diff = 0;

					for (var i = start; i <= max; i++) {
						if (diff + spanWidth <= availWidth) {
							diff += spanWidth;
						}
						else {
							break;
						}
					}
					if (diff > 0) {
						columnWidth += diff;
						contWidth += diff;

						this._dom.sheetContainer.style.width = contWidth + "px";
						this._dom.validityContainer.style.width = contWidth + "px";
						this._dom.rightColumn.style.width = columnWidth + "px";
					}
				}
			}
		}
	}

	generateLink(optsArg) {
		const opts = {
			id: 0,
			source: "",
			line: 0,
			direction: 0
		};
		let linkHref = "";
		const { data } = store.getState().detail;

		// merge parametru
		for (let key in optsArg) {
			opts[key] = optsArg[key];
		}

		// nezadal jsem id, source -> pokud mozno vezmu z detailu
		if (!opts.id && !opts.source && data?.id && data?.source) {
			opts.id = data.id;
			opts.source = data.source;
		}

		// vsechny 3 jsou povinne
		if (opts.id && opts.source && opts.line && opts.direction) {
			linkHref = CONFIG.defaultLang !== "cs" ? `/${CONFIG.defaultLang}` : "" + "/?" + (new URLSearchParams({
				id: opts.id,
				source: opts.source,
				timeboard: JSON.stringify({
					l: opts.line,
					d: opts.direction
				})
			})).toString();
		}

		return linkHref;
	}

	_getSourcesData(sheet) {
		var dataAgencies = sheet.agencies || [];
		var dataOrigins = sheet.origins || [];
		var names = {};
		var agencies = [];
		var origins = [];

		dataAgencies.forEach(function(agency) {
			var name = agency.name || agency.txt;
			agencies.push(agency.url ? '<a href="' + agency.url + '" target="_blank">' + name + '</a>' : name);
			names[name] = 1;
		});

		dataOrigins.forEach(function(origin) {
			var name = origin.name || origin.txt;

			if (name in names) return;

			origins.push(origin.url ? '<a href="' + origin.url + '" target="_blank">' + name + '</a>' : name);
		});

		return {
			empty: !agencies.length && !origins.length,
			agencies: agencies,
			origins: origins
		};
	}

	_getIntervalDate(dateStr) {
		var date = isoZoneToUTC(dateStr);
		var m = date.getUTCMonth() + 1;
		var d = date.getUTCDate();

		return d + ". " + m + ".";
	}

	_resetValidity() {
		var validityItem = this._dom.validityContainer.querySelector(".active");
		if (validityItem) {
			validityItem.classList.remove("active");
		}
	}

	_setValidation() {
		var validityItem = this._dom.validityContainer.querySelector(".active");
		this._validity = validityItem ? validityItem.__validity : null;
	}

	_formatTime(time) {
		if (typeof time === "number" && time > 60) {
			var hours = (time / 60) >>> 0;
			var rest = time - hours * 60;

			return (hours + ":" + (rest < 10 ? "0" + rest : rest));
		}
		else {
			return time;
		}
	}

	_sortLines(lines) {
		var items = [];

		// projdeme si jednotlive polozky - pridame si data pro razeni
		lines.forEach(function(i) {
			var sortObj = {
				type: 2, // 0 cislo, 1 cislo a znaky, 2 znaky
				number: 0,
				str: ""
			};

			var title = i.title;

			if (title.match(/^\d+$/)) {
				sortObj.type = 0;
				sortObj.number = parseInt(title);
			}
			else {
				var m = title.match(/^([^\d]+)(\d+)/);

				if (m && m.length == 3) {
					sortObj.type = 1;
					sortObj.str = m[1].trim();
					sortObj.number = parseInt(m[2]);
				}
				else {
					sortObj.str = title.trim();
				}
			}

			// ulozime
			i.sortObj = sortObj;
			items.push(i);
		});

		// seradime - 1) cisla, 2) znaky a cisla, 3) znaky
		items.sort(function(a, b) {
			if (a.sortObj.type < b.sortObj.type) {
				return -1;
			}
			else if (a.sortObj.type > b.sortObj.type) {
				return 1;
			}
			else {
				switch (a.sortObj.type) {
					case 0:
						return (a.sortObj.number - b.sortObj.number);

					case 1:
						var test = Mapy.Util.localeCompare(a.sortObj.str, b.sortObj.str);

						if (test != 0) return test;
						else return (a.sortObj.number - b.sortObj.number);

					case 2:
						return Mapy.Util.localeCompare(a.sortObj.str, b.sortObj.str);
				}
			}
		});

		return items;
	}
};
